export const POTENTIAL_IMPACTS_SOURCE_ID = "potential-impacts";
export const POTENTIAL_IMPACTS_MARKER_LAYER_ID = "potential-impacts-marker";
export const POTENTIAL_IMPACTS_LABEL_LAYER_ID = "potential-impacts-label";
export const POTENTIAL_IMPACTS_POWERLINES_LAYER_ID =
  "potential-impacts-powerlines";
